var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimsGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M8.83333 2H7.16667V6.44167L3 12H13L8.83333 6.44167V2Z",
    fill: "url(#paint0_linear_1058_1268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3334 12.3334L10.5001 5.89171V2.41671L11.6251 1.00837C11.8417 0.733374 11.6501 0.333374 11.3001 0.333374H4.70006C4.35006 0.333374 4.1584 0.733374 4.37506 1.00837L5.50006 2.41671V5.89171L0.666731 12.3334C0.258398 12.8834 0.650065 13.6667 1.3334 13.6667H14.6667C15.3501 13.6667 15.7417 12.8834 15.3334 12.3334ZM3.00006 12L7.16673 6.44171V2.00004H8.8334V6.44171L13.0001 12H3.00006Z",
    fill: "url(#paint1_linear_1058_1268)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_1268",
    x1: 3.40842,
    y1: 7,
    x2: 12.5545,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1058_1268",
    x1: 1.1133,
    y1: 7.00004,
    x2: 14.8311,
    y2: 7.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimsGreen);
export default __webpack_public_path__ + "static/media/Lims-green.e59a3aa8b3c3c35b10b3b7de2af9e0ce.svg";
export { ForwardRef as ReactComponent };